import React, { useEffect, useState } from "react";
import appConst from "../Utilities/appConst.json";
import SummaryItemDetails from "./SummaryItemDetails";
import { CoverPreview } from "../shared/ui/cover-preview";
import { buildCoverPreviewData } from "../shared/ui/cover-preview/utils";
import { buildBasketItemImageUrl } from "../Utilities/basketImage";
import { useSelector } from "react-redux";

const SummaryItemBook = (props) => {
  const [heightQuantity, setHeightQuantity] = useState(0);
  const [widthQuantity, setWidthQuantity] = useState(0);
  const basket = useSelector((state) => state.basket.basket);
  const itemId = props.item?.item_id ?? props.id ?? "unknown";

  const imageUrl = buildBasketItemImageUrl(props.item, basket);
  const coverPreviewData = buildCoverPreviewData(props.item, imageUrl);

  useEffect(() => {
    const format = props.item.format.toString();
    if (
      format.startsWith(appConst.MOSAIC_CODE) &&
      format.length === appConst.MOSAIC_CODE_LENGTH
    ) {
      setHeightQuantity(format[1]);
      setWidthQuantity(format[2]);
    }
  }, []);

  return (
    <div className="summary_item_container" data-testid={`summary-item-${itemId}`}>
      <div className="basket_item">
        <div
          className="relative flex items-center justify-center overflow-hidden w-basket-img-sm h-basket-img-sm md:w-basket-img-lg md:h-basket-img-lg"
          style={{
            flexShrink: 0,
          }}
          data-testid={`summary-item-image-${itemId}`}
        >
          {coverPreviewData ? (
            <CoverPreview
              data={coverPreviewData}
              className={coverPreviewData.aspectRatio >= 1 ? "w-full" : "h-full"}
            />
          ) : (
            <img
              src={imageUrl}
              alt={props.item.title || "Product"}
              className="object-contain shadow-[3px_3px_9px_#DADADA] w-full h-full"
            />
          )}
        </div>
        <div
          style={{ flexGrow: 1, marginInlineStart: "24px" }}
          data-testid={`summary-item-details-wrapper-${itemId}`}
        >
          <SummaryItemDetails
            isMosaic={false}
            couponsItem={props.couponsItem}
            quantity={props.item.quantity}
            material={props.item.material}
            id={props.id}
            format={props.item.format}
            heightQuantity={heightQuantity}
            widthQuantity={widthQuantity}
          ></SummaryItemDetails>
        </div>
      </div>
    </div>
  );
};
export default SummaryItemBook;
